import { DataInfoCard, Icons } from "../../shared";
import { useLocalStorage } from "react-use";
import { DeviceErrorsTable } from "./DeviceErrorsTable";
import { ServerErrorsTable } from "./ServerErrorsTables";

export const ErrorsView: React.FC = () => {
    const [errorSource, setErrorSource] = useLocalStorage<"device" | "server">("ExceptionsViewLastSelection", "server");
    const selectedCardClasses = "border border-separators-page p-5 flex flex-1 gap-3 min-w-min flex-grow shadow-sm border-brand-primary text-brand-primary ring-2 ring-brand-primary shadow-md transition-all";
    const cardClasses = "border border-separators-page p-5 flex flex-1 gap-3 min-w-min flex-grow hover:shadow-lg transition-all"

    return (
        <>
            <div className="flex justify-center">
                <div className="flex flex-wrap gap-4 w-full max-w-2xl m-6">
                    <DataInfoCard
                        Icon={Icons.Details}
                        onClick={() => setErrorSource("device")}
                        className={errorSource === "device" ? selectedCardClasses : cardClasses}
                        hoverText={(
                            <div className="flex flex-col gap-2">
                                <p>
                                    Issues reported by devices — one row per deduplicated error (collapsed by root cause),
                                    not per occurrence. Counts roll up across all devices reporting the same issue.
                                </p>
                                <p>
                                    Workflow: <span className="font-semibold">Resolve</span> tags an issue with the
                                    firmware version it was fixed in; if it recurs on that version or newer it&apos;s
                                    flagged as <span className="font-semibold">Regressed</span>.{" "}
                                    <span className="font-semibold">Ignore</span> (with a required reason) acknowledges
                                    an issue we don&apos;t plan to fix.
                                </p>
                            </div>
                        )}
                        title="Device Errors"
                    />
                    <DataInfoCard
                        Icon={Icons.Details}
                        onClick={() => setErrorSource("server")}
                        className={errorSource === "server" ? selectedCardClasses : cardClasses}
                        hoverText="Recent errors from the server log since the app last started. See CloudWatch for older entries and full context (search by trace id)."
                        title="Server Errors"
                    />
                </div>
            </div>
            {errorSource === "device" && <DeviceErrorsTable />}
            {errorSource === "server" && <ServerErrorsTable />}
        </>
    );
}